import React, { useEffect, useState } from "react";
import {
  Button,
  Row,
  Col,
  Container,
  Badge,
  Card,
  CardBody,
  UncontrolledCollapse,
  Input,
  Tooltip,
  FormGroup,
  Label,
} from "reactstrap";
import {
  ACTIVE_CHANGE,
  GET_LICENSE_TEMPLATE,
} from "../../../constants/ApiPaths";
import { authHeader } from "../../../functions/CoreFunctions";
import API from "../../../redux/actions/API";
import CustomPageLoading from "../../CustomComponents/CustomPageLoading";
import Pagination from "react-js-pagination";
import moment from "moment";
import { Link } from "react-router-dom";
import { AGENCY_CREATE_TEMPLATE } from "../../../constants/RoutePaths";
import Templatecreatemodel from "./Templatecreatemodel";
import { CustomAlertMessage } from "../../../functions/CustomFunctions";
import { useSnackbar } from "notistack";
import { getAgencyId } from "../../common/CommonFunctions";

import { Info } from "../../common/Info";
import { useSelector } from "react-redux";
import { Box, Tab, Tabs, Typography } from "@mui/material";
import AgencyTemplatecreatemodel from "./AgencyTemplatecreatemodal";

const initialValues = {
  licenseName: "",
  licenseDescription: "",
};
const agencyinitialValues = {
  licenseName: "",
  licenseDescription: "",
  isOnlinePayment: false,
  isOfflinePayment: false
};
const filterInitialValues = {
  licenseName: "",
  isActive: "",
  templateStatus: "",
};
const agencyfilterInitialValues = {
  licenseName: "",
  isActive: "",
  templateStatus: "",
};
function TemplateList() {
  const [TemplateDetails, setTemplateDetails] = useState([]);
  const [AgencyTemplateDetails, setAgencyTemplateDetails] = useState([]);
  const [agencytotalrecords, setAgencyTotalRecords] = useState(0);
  const [Loading, setLoading] = useState(false);
    let rowperpage = 10;

  const [currentpage, setCurrentPage] = useState(0);
  const [totalrecords, setTotalRecords] = useState(0);
  const [agencycurrentpage, setAgencyCurrentPage] = useState(0);
  const [modal, setModal] = useState(false);
  const [agencymodal, setAgencyModal] = useState(false);
  const [reCall, setReCall] = useState(0);
  const [agencyreCall, setAgencyReCall] = useState(0);
  const Delete = useSelector((state) => state.Agencydelete);
  const toggle = () => {
    if (Delete) return;
    setModal(!modal);
  };
   const agencytoggle = () => {
    if (Delete) return;
    setAgencyModal(!agencymodal);
  };
  const { enqueueSnackbar } = useSnackbar();
  const [buttonLoading, setbuttonLoading] = useState(false);
  const [filterhandle, setfilterhandle] = useState(false);
  const [Filterstate, setFilterstate] = useState(filterInitialValues);
  const filtertoggle = () => setfilterhandle(!filterhandle);
  const agencyfiltertoggle = () => setAgencyfilterhandle(!agencyfilterhandle);
  const [agencyfilterhandle, setAgencyfilterhandle] = useState(false);
  const [AgencyFilterstate, setAgencyFilterstate] = useState(agencyfilterInitialValues);
  const [id, setid] = useState("");
  const [tooltipOpen, setTooltipOpen] = useState(false);

  const tooltiptoggle = (id) => {
    setid(id);
    setTooltipOpen(!tooltipOpen);
  };
  let filterHandle = (e) => {
    const { name, value } = e.target;
    setFilterstate({ ...Filterstate, [name]: value });
  };
let agencyfilterHandle = (e) => {
    const { name, value } = e.target;
    setAgencyFilterstate({ ...AgencyFilterstate, [name]: value });
  };
  let GetTemplate = async () => {
    setLoading(true);
    const config = {
      method: "GET",
      url: GET_LICENSE_TEMPLATE,
      headers: authHeader(),
      params: {
        agencyId: getAgencyId(),
        offset: currentpage,
        count: rowperpage,
        isAgencyLicense: false,
        ...Filterstate,
      },
    };
    try {
      const response = await API(config);
      const { status, data, totalCount } = response.data;
      if (status === "Success") {
        setTemplateDetails(data);
        setTotalRecords(totalCount);
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        CustomAlertMessage(data.message, "error", enqueueSnackbar);
      }
    } finally {
      setLoading(false);
    }
  };
 let GetAgencyTemplate = async () => {
    setLoading(true);
    const config = {
      method: "GET",
      url: GET_LICENSE_TEMPLATE,
      headers: authHeader(),
      params: {
        agencyId: getAgencyId(),
        offset: agencycurrentpage,
        count: rowperpage,
        isAgencyLicense: true,
        ...AgencyFilterstate,
      },
    };
    try {
      const response = await API(config);
      const { status, data, totalCount } = response.data;
      if (status === "Success") {
        setAgencyTemplateDetails(data);
        setAgencyTotalRecords(totalCount);
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        CustomAlertMessage(data.message, "error", enqueueSnackbar);
      }
    } finally {
      setLoading(false);
    }
  };
  // template Status
  const getTemplateStatus = {
    Approved: (
      <Badge color="success" className="mr-3 badge-success-soft">
        Approved
      </Badge>
    ),
    Pending: (
      <Badge color="warning" className="mr-3 badge-warning-soft">
        Pending
      </Badge>
    ),
    New: (
      <Badge color="info" className="mr-3 badge-info-soft">
        New
      </Badge>
    ),
    Rejected: (
      <Badge color="danger" className="mr-3 badge-danger-soft">
        Rejected
      </Badge>
    ),
  };

  // getTemplateActive
  

  const onPageChange = (page) => {
    setCurrentPage(page - 1);
  };
const onAgencyPageChange = (page) => {
    setAgencyCurrentPage(page - 1);
  };
  let Activestatus = async (e) => {
    if (Delete) return;
    setbuttonLoading(true);
    const config = {
      method: "PUT",
      url: ACTIVE_CHANGE,
      headers: authHeader(),
      data: {
        templateId: e.currentTarget.dataset.templateid,
        isActive: e.target.checked,
      },
    };
    try {
      const response = await API(config);
      const { status,  message } = response.data;
      if (status === "Success") {
        CustomAlertMessage(message, "success", enqueueSnackbar);
        GetTemplate();
         GetAgencyTemplate();
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        CustomAlertMessage(data.message, "error", enqueueSnackbar);
      }
    } finally {
      setbuttonLoading(false);
    }
  };



  const clearButton = () => {
    setFilterstate({ ...filterInitialValues }); //Object.assign({}, filterInitialValues)
  };
  const agencyClearButton = () => {
    setAgencyFilterstate({ ...agencyfilterInitialValues }); //Object.assign({}, filterInitialValues)
  };
  useEffect(() => {
    GetTemplate();
    GetAgencyTemplate();
  }, [currentpage, Filterstate, reCall, agencycurrentpage, AgencyFilterstate]);
 const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    handleClick(newValue === 0 ? 'agency' : 'customer'); // Call your existing handler
  };

  const handleClick = (type) => {
    console.log(`Switched to ${type}`);
    // Your logic for switching views
  };
  return (
    <div>
      <div className="agency-wrapper">
        <Container fluid>
          <div className="page-title">
            <Box sx={{ width: '100%' }}>
          <Tabs
        value={value}
        onChange={handleChange}
        textColor="primary"
        indicatorColor="primary"
        aria-label="Agency and Customer Tabs"
        sx={{ gap: '2rem'}}
      >
        <Tab label="Agency" sx={{ width: '150px', fontSize: '18px', fontWeight: '700', color: '#212529', textTransform: 'none'}} />
        <Tab label="Customer" sx={{  width: '150px', fontSize: '18px', fontWeight: '700', color: '#212529', textTransform: 'none'}} />
      </Tabs>
      <Box sx={{ mt: 6 }}>
        {value === 0 && (
          <div>
          <div className="top-btn">
              <Button onClick={agencyfiltertoggle} color="link" id="toggler">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14.371"
                  height="14.371"
                  viewBox="0 0 14.371 14.371"
                >
                  <path
                    id="Icon_awesome-filter"
                    data-name="Icon awesome-filter"
                    d="M13.7,0H.674A.674.674,0,0,0,.2,1.15L5.389,6.342v5.784a.674.674,0,0,0,.287.552l2.246,1.571a.674.674,0,0,0,1.06-.552V6.342L14.173,1.15A.674.674,0,0,0,13.7,0Z"
                    fill="#1b3e6f"
                  />
                </svg>
              </Button>
              <Button disabled={Delete} onClick={agencytoggle} color="primary">
              {/* <Button disabled={Delete} onClick={toggle} color="primary"> */}
                <svg
                  className="mr-3"
                  xmlns="http://www.w3.org/2000/svg"
                  width="12.401"
                  height="12.402"
                  viewBox="0 0 12.401 12.402"
                >
                  <g
                    id="Icon_feather-plus"
                    data-name="Icon feather-plus"
                    transform="translate(-6.6 -6.6)"
                  >
                    <path
                      id="Path_82"
                      data-name="Path 82"
                      d="M18,7.5V18.1"
                      transform="translate(-5.199)"
                      fill="none"
                      stroke="#fff"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="1.8"
                    />
                    <path
                      id="Path_83"
                      data-name="Path 83"
                      d="M7.5,18H18.1"
                      transform="translate(0 -5.199)"
                      fill="none"
                      stroke="#fff"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="1.8"
                    />
                  </g>
                </svg>
                New Template
              </Button>
          </div>
          <div>
          <Row>
            <Col sm="12" xl={{ size: 10, offset: 1 }}>
              <UncontrolledCollapse
                isOpen={agencyfilterhandle}
                toggler="#toggler"
                className="mt-4"
              >
                <Card>
                  <CardBody>
                    <Row>
                      <Col md="6" lg="6" xl="3">
                        <FormGroup>
                          <span>Select Status</span>
                          <Input
                            type="select"
                            name="templateStatus"
                            value={AgencyFilterstate.templateStatus}
                            onChange={agencyfilterHandle}
                          >
                            <option value="">Select Status</option>
                            {[
                              "New",
                              "Pending",
                              "Send Request",
                              "Approved",
                              "Rejected",
                            ].map((i) => (
                              <option value={i}>{i}</option>
                            ))}
                          </Input>
                        </FormGroup>
                      </Col>
                      <Col md="6" lg="6" xl="4">
                        <FormGroup>
                          <span>Select Template Status</span>
                          <Input
                            type="select"
                            name="isActive"
                            value={AgencyFilterstate.isActive}
                            onChange={agencyfilterHandle}
                          >
                            <option value="">Select template Status</option>
                            <option value={true}>Active</option>
                            <option value={false}>InActive</option>
                          </Input>
                        </FormGroup>
                      </Col>
                      <Col md="6" lg="6" xl="3">
                        <FormGroup>
                          <span>Search Template Name</span>
                          <Input
                            type="text"
                            name="licenseName"
                            value={AgencyFilterstate.licenseName}
                            onChange={agencyfilterHandle}
                            placeholder="Search Template Name"
                          />
                        </FormGroup>
                      </Col>
                      <Col md="6" lg="6" xl="2">
                        <Button
                          color="danger"
                          block
                          className="mt-lg-4"
                          onClick={agencyClearButton}
                        >
                          Clear
                        </Button>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </UncontrolledCollapse>
            </Col>
          </Row>
           {Loading || buttonLoading ? <CustomPageLoading /> : ""}
          {Loading ? (
            ""
          ) : AgencyTemplateDetails.length === 0 ? (
            <div className="license-card">
              <Row>
                <Col md="12">
                  <center>No records Found</center>
                </Col>
              </Row>
            </div>
          ) : (
            AgencyTemplateDetails.map((data) => {
              const {
                licenseName,
                createdDate,
                templateStatus,
                licensePlanCount,
                templateId,
                totalUser,
                isActive,
              } = data;
              return (
                <div className="license-card">
                  <Row>
                    <Col>
                      <h4>{licenseName}</h4>
                    </Col>
                  </Row>
                  <Row>
                    <Col sm="6" md="2">
                      <div className="info">
                        <p>{moment(createdDate).format("MM/DD/YYYY")}</p>
                        <span> Created Date</span>
                      </div>
                    </Col>
                    <Col sm="6" md="2">
                      <div className="info">
                        <p>{licensePlanCount}</p>
                        <span>No of Plans</span>
                      </div>
                    </Col>
                    <Col sm="6" md="2">
                      <div className="info">
                        <p>{totalUser}</p>
                        <span>Total Users</span>
                      </div>
                    </Col>
                    <Col sm="6" md="2">
                      <div className="info">
                        {getTemplateStatus[templateStatus]}

                        <span>Status</span>
                      </div>
                    </Col>
                    <Col sm="6" md="2" className="status-section">
                      <FormGroup switch>
                        <Input
                          type="switch"
                          disabled={Delete}
                          style={{ cursor: "pointer" }}
                          className="ml-2"
                          checked={isActive}
                          onChange={Activestatus}
                          data-templateid={templateId}
                          name="isMandatory"
                          id={"exampleCustomSwitch" + templateId}
                          label={isActive ? "Active" : "InActive"}
                        />
                        <Label>{isActive ? "Active" : "InActive"}</Label>
                      </FormGroup>
                    </Col>

                    <Col sm="6" md="2" className="status-section">
                      <Link
                        to={{
                          pathname: `${AGENCY_CREATE_TEMPLATE}/${templateId}`,
                          licenseName: licenseName,
                        }}
                      >
                        {isActive || Delete ? (
                          <>
                            {" "}
                            <Button color="primary" size="sm">
                              View
                            </Button>
                          </>
                        ) : (
                          <Button color="primary" size="sm">
                            Edit
                          </Button>
                        )}
                      </Link>
                    </Col>
                  </Row>
                </div>
              );
            })
          )}
          <div className="d-flex flex-row py-4 justify-content-end">
            <Pagination
              itemClass="page-item"
              linkClass="page-link"
              itemsCountPerPage={rowperpage}
              totalItemsCount={agencytotalrecords}
              activePage={agencycurrentpage + 1}
              onChange={onAgencyPageChange}
            />
          </div>
          </div>
        </div>
        )}
        {value === 1 && (
          <div>
            <div className="top-btn">
              <Button onClick={filtertoggle} color="link" id="toggler">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14.371"
                  height="14.371"
                  viewBox="0 0 14.371 14.371"
                >
                  <path
                    id="Icon_awesome-filter"
                    data-name="Icon awesome-filter"
                    d="M13.7,0H.674A.674.674,0,0,0,.2,1.15L5.389,6.342v5.784a.674.674,0,0,0,.287.552l2.246,1.571a.674.674,0,0,0,1.06-.552V6.342L14.173,1.15A.674.674,0,0,0,13.7,0Z"
                    fill="#1b3e6f"
                  />
                </svg>
              </Button>

              <Button disabled={Delete} onClick={toggle} color="primary">
                <svg
                  className="mr-3"
                  xmlns="http://www.w3.org/2000/svg"
                  width="12.401"
                  height="12.402"
                  viewBox="0 0 12.401 12.402"
                >
                  <g
                    id="Icon_feather-plus"
                    data-name="Icon feather-plus"
                    transform="translate(-6.6 -6.6)"
                  >
                    <path
                      id="Path_82"
                      data-name="Path 82"
                      d="M18,7.5V18.1"
                      transform="translate(-5.199)"
                      fill="none"
                      stroke="#fff"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="1.8"
                    />
                    <path
                      id="Path_83"
                      data-name="Path 83"
                      d="M7.5,18H18.1"
                      transform="translate(0 -5.199)"
                      fill="none"
                      stroke="#fff"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="1.8"
                    />
                  </g>
                </svg>
                New Template
              </Button>
            </div>

          <Row>
            <Col sm="12" xl={{ size: 10, offset: 1 }}>
              <UncontrolledCollapse
                isOpen={filterhandle}
                toggler="#toggler"
                className="mt-4"
              >
                <Card>
                  <CardBody>
                    <Row>
                      <Col md="6" lg="6" xl="3">
                        <FormGroup>
                          <span>Select Status</span>
                          <Input
                            type="select"
                            name="templateStatus"
                            value={Filterstate.templateStatus}
                            onChange={filterHandle}
                          >
                            <option value="">Select Status</option>
                            {[
                              "New",
                              "Pending",
                              "Send Request",
                              "Approved",
                              "Rejected",
                            ].map((i) => (
                              <option value={i}>{i}</option>
                            ))}
                          </Input>
                        </FormGroup>
                      </Col>
                      <Col md="6" lg="6" xl="4">
                        <FormGroup>
                          <span>Select Template Status</span>
                          <Input
                            type="select"
                            name="isActive"
                            value={Filterstate.isActive}
                            onChange={filterHandle}
                          >
                            <option value="">Select template Status</option>
                            <option value={true}>Active</option>
                            <option value={false}>InActive</option>
                          </Input>
                        </FormGroup>
                      </Col>
                      <Col md="6" lg="6" xl="3">
                        <FormGroup>
                          <span>Search Template Name</span>
                          <Input
                            type="text"
                            name="licenseName"
                            value={Filterstate.licenseName}
                            onChange={filterHandle}
                            placeholder="Search Template Name"
                          />
                        </FormGroup>
                      </Col>
                      <Col md="6" lg="6" xl="2">
                        <Button
                          color="danger"
                          block
                          className="mt-lg-4"
                          onClick={clearButton}
                        >
                          Clear
                        </Button>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </UncontrolledCollapse>
            </Col>
          </Row>

          {Loading || buttonLoading ? <CustomPageLoading /> : ""}
          {Loading ? (
            ""
          ) : TemplateDetails.length === 0 ? (
            <div className="license-card">
              <Row>
                <Col md="12">
                  <center>No records Found</center>
                </Col>
              </Row>
            </div>
          ) : (
            TemplateDetails.map((data) => {
              const {
                licenseName,
                createdDate,
                templateStatus,
                licensePlanCount,
                templateId,
                totalUser,
                isActive,
              } = data;
              return (
                <div className="license-card">
                  <Row>
                    <Col>
                      <h4>{licenseName}</h4>
                    </Col>
                  </Row>
                  <Row>
                    <Col sm="6" md="2">
                      <div className="info">
                        <p>{moment(createdDate).format("MM/DD/YYYY")}</p>
                        <span> Created Date</span>
                      </div>
                    </Col>
                    <Col sm="6" md="2">
                      <div className="info">
                        <p>{licensePlanCount}</p>
                        <span>No of Plans</span>
                      </div>
                    </Col>
                    <Col sm="6" md="2">
                      <div className="info">
                        <p>{totalUser}</p>
                        <span>Total Users</span>
                      </div>
                    </Col>
                    <Col sm="6" md="2">
                      <div className="info">
                        {getTemplateStatus[templateStatus]}

                        <span>Status</span>
                      </div>
                    </Col>
                    <Col sm="6" md="2" className="status-section">
                      <FormGroup switch>
                        <Input
                          type="switch"
                          disabled={Delete}
                          style={{ cursor: "pointer" }}
                          className="ml-2"
                          checked={isActive}
                          onChange={Activestatus}
                          data-templateid={templateId}
                          name="isMandatory"
                          id={"exampleCustomSwitch" + templateId}
                          label={isActive ? "Active" : "InActive"}
                        />
                        <Label>{isActive ? "Active" : "InActive"}</Label>
                      </FormGroup>
                    </Col>

                    <Col sm="6" md="2" className="status-section">
                      <Link
                        to={{
                          pathname: `${AGENCY_CREATE_TEMPLATE}/${templateId}`,
                          licenseName: licenseName,
                        }}
                      >
                        {isActive || Delete ? (
                          <>
                            {" "}
                            <Button color="primary" size="sm">
                              View
                            </Button>
                          </>
                        ) : (
                          <Button color="primary" size="sm">
                            Edit
                          </Button>
                        )}
                      </Link>
                    </Col>
                  </Row>
                </div>
              );
            })
          )}
          <div className="d-flex flex-row py-4 justify-content-end">
            <Pagination
              itemClass="page-item"
              linkClass="page-link"
              itemsCountPerPage={rowperpage}
              totalItemsCount={totalrecords}
              activePage={currentpage + 1}
              onChange={onPageChange}
            />
            </div>
        </div>
        )}
      </Box>
    </Box>
          </div>
        </Container>
      </div>
      <Templatecreatemodel
        reCall={reCall}
        formData={initialValues}
        setReCall={setReCall}
        toggle={toggle}
        modal={modal}
        isAgency={value === 0 ? true : false}
      />
       <AgencyTemplatecreatemodel
        reCall={agencyreCall}
        formData={agencyinitialValues}
        setReCall={setAgencyReCall}
        toggle={agencytoggle}
        modal={agencymodal}
        isAgency={value === 0 ? true : false}
      />
    </div>
  );
}

export default TemplateList;
